var _path, _path2, _g, _path3, _g2, _path4, _g3, _path5, _path6, _g4, _path7, _path8, _path9, _path0, _g5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPetProtectCopay(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.451 20.8632C41.451 22.1833 41.3283 23.4756 41.0896 24.727C40.993 25.2388 40.8768 25.7419 40.7435 26.2388C39.8943 29.3993 38.314 32.2572 36.1938 34.6243C36.1206 34.7039 36.0496 34.7858 35.9744 34.8631C32.2051 38.9484 26.806 41.5052 20.809 41.5052C11.0365 41.5052 2.85068 34.7148 0.713297 25.5935C0.356507 24.0756 0.167297 22.4909 0.167297 20.8632C0.167297 19.6914 0.263897 18.5408 0.455207 17.4228C2.09153 7.65882 10.5806 0.221252 20.809 0.221252C32.2093 0.221252 41.451 9.46293 41.451 20.8632",
    fill: "#C8CCCF"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1_6315",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 42,
    height: 42
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.455295 17.4229C0.263775 18.5409 0.167175 19.6913 0.167175 20.8631V20.8631C0.167175 22.4908 0.356385 24.0757 0.713385 25.5935V25.5935C2.85077 34.7149 11.0366 41.5052 20.8091 41.5052V41.5052C26.8059 41.5052 32.205 38.9485 35.9745 34.8629V34.8629C36.0497 34.7857 36.1206 34.7038 36.1939 34.6244V34.6244C38.3139 32.2571 39.8943 29.3994 40.7436 26.2387V26.2387C40.8767 25.742 40.9931 25.2386 41.0897 24.7271V24.7271C41.3284 23.4757 41.4509 22.1834 41.4509 20.8631V20.8631C41.4509 9.46281 32.2094 0.221344 20.8091 0.221344V0.221344C10.5807 0.221344 2.09162 7.65891 0.455295 17.4229",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1_6315)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.0795 7.29997H13.6044C12.6982 7.29997 11.7986 6.64666 11.7986 6.04249V5.82262C11.7986 5.21845 12.6982 4.67329 13.6044 4.67329H15.9026C16.809 4.67329 17.5444 4.29088 17.5444 3.68671C17.5444 3.08254 18.2798 2.70328 19.186 2.70328H33.5012C35.5368 4.01662 37.4083 5.32996 39.0795 7.29997",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_1_6315",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 42,
    height: 42
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.455295 17.4229C0.263775 18.5409 0.167175 19.6913 0.167175 20.8631V20.8631C0.167175 22.4908 0.356385 24.0757 0.713385 25.5935V25.5935C2.85077 34.7149 11.0366 41.5052 20.8091 41.5052V41.5052C26.8059 41.5052 32.205 38.9485 35.9745 34.8629V34.8629C36.0497 34.7857 36.1206 34.7038 36.1939 34.6244V34.6244C38.3139 32.2571 39.8943 29.3994 40.7436 26.2387V26.2387C40.8767 25.742 40.9931 25.2386 41.0897 24.7271V24.7271C41.3284 23.4757 41.4509 22.1834 41.4509 20.8631V20.8631C41.4509 9.46281 32.2094 0.221344 20.8091 0.221344V0.221344C10.5807 0.221344 2.09162 7.65891 0.455295 17.4229",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_1_6315)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.2522 25.0468V25.3261C10.2522 26.0966 9.62678 26.7222 8.85608 26.7222H-6.72424C-6.71311 26.6411 -6.69904 26.563 -6.68497 26.4819C-6.35842 24.5275 -5.81956 22.6454 -5.09086 20.8586H2.71337C3.48386 20.8586 4.10945 21.4839 4.10945 22.2546C4.10945 23.0253 4.73483 23.6507 5.50553 23.6507H8.85608C9.62678 23.6507 10.2522 24.2761 10.2522 25.0468",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_1_6315",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 42,
    height: 42
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.455295 17.4229C0.263775 18.5409 0.167175 19.6913 0.167175 20.8631V20.8631C0.167175 22.4908 0.356385 24.0757 0.713385 25.5935V25.5935C2.85077 34.7149 11.0366 41.5052 20.8091 41.5052V41.5052C26.8059 41.5052 32.205 38.9485 35.9745 34.8629V34.8629C36.0497 34.7857 36.1206 34.7038 36.1939 34.6244V34.6244C38.3139 32.2571 39.8943 29.3994 40.7436 26.2387V26.2387C40.8767 25.742 40.9931 25.2386 41.0897 24.7271V24.7271C41.3284 23.4757 41.4509 22.1834 41.4509 20.8631V20.8631C41.4509 9.46281 32.2094 0.221344 20.8091 0.221344V0.221344C10.5807 0.221344 2.09162 7.65891 0.455295 17.4229",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_1_6315)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.3201 20.0074H34.0474C33.6944 20.0074 33.3735 19.8631 33.1435 19.6332C32.9136 19.403 32.7695 19.0826 32.7695 18.7291C32.7695 18.0229 33.3412 17.4511 34.0474 17.4511H37.0684C37.2917 17.4511 37.496 17.3606 37.6426 17.2117C37.7913 17.0653 37.8818 16.861 37.8818 16.6378C37.8818 16.1894 37.517 15.8246 37.0684 15.8246H35.9065C35.2003 15.8246 34.6285 15.2528 34.6285 14.5464V14.3141C34.6285 13.6077 35.2003 13.036 35.9065 13.036H40.1544C41.2374 15.1831 41.9833 17.5303 42.3201 20.0074",
    fill: "white"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.7235 36.1081L16.6496 32.9526V28.2274C16.6496 25.9936 20.707 24.183 20.707 24.183C22.9479 24.183 24.7642 25.9936 24.7642 28.2274V36.0909H33.5346L33.8822 22.7737L20.707 11.8283L8.17126 22.6565L8.21473 36.1763L14.5895 36.0909L16.7235 36.1081Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_1_6315",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 42,
    height: 42
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 42H42V0H0V42Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_1_6315)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.21051 40.6216H37.5079V36.5049H4.21051V40.6216Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.927 19.936V36.1816H7.83911L7.98779 22.6217L10.927 19.936Z",
    fill: "#D7DCDC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.9095 40.5502H37.4207V36.6824H10.9095V40.5502Z",
    fill: "#EDF1F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.8063 11.6605C20.8811 11.5977 20.9872 11.5925 21.0672 11.6449L21.0883 11.6606L33.9046 22.4401C33.947 22.4758 33.9741 22.526 33.9809 22.5803L33.9826 22.6078V36.3632C33.9826 36.4762 33.8972 36.5692 33.7874 36.5811L33.7635 36.5824H24.9931C24.8801 36.5824 24.7871 36.4969 24.7752 36.3871L24.7739 36.3632V28.4998C24.7739 26.3873 23.0559 24.6747 20.9359 24.6747C18.8394 24.6747 17.1358 26.3495 17.0982 28.4295L17.0976 28.4998V34.2193C17.0976 34.3404 16.9995 34.4385 16.8785 34.4385C16.7655 34.4385 16.6725 34.353 16.6606 34.2432L16.6593 34.2193V28.4998C16.6593 26.145 18.5741 24.2365 20.9359 24.2365C23.2733 24.2365 25.1727 26.1058 25.2116 28.4271L25.2122 28.4998V36.1439H33.5444V22.7098L20.9471 12.1145L8.32737 22.7098V36.1439L14.8184 36.1441C14.9313 36.1441 15.0243 36.2296 15.0362 36.3393L15.0375 36.3632C15.0375 36.4762 14.952 36.5692 14.8422 36.5811L14.8184 36.5824H8.10823C7.99528 36.5824 7.90228 36.4969 7.89038 36.3871L7.8891 36.3632V22.6078C7.8891 22.5523 7.91014 22.4992 7.94738 22.459L7.96733 22.44L20.8063 11.6605Z",
    fill: "#2A323A"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.05597 40.6617H10.9484V36.7534H4.05597V40.6617Z",
    fill: "#D7DCDC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.28713 36.2858H37.5845C37.7055 36.2858 37.8037 36.3839 37.8037 36.5049V40.6216C37.8037 40.7426 37.7055 40.8407 37.5845 40.8407H4.28713C4.1661 40.8407 4.06799 40.7426 4.06799 40.6216V36.5049C4.06799 36.3839 4.1661 36.2858 4.28713 36.2858ZM37.3653 40.4023V36.724H4.50616V40.4023H37.3653Z",
    fill: "#2A323A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.6834 11.7624C20.1955 11.3371 20.9555 11.4074 21.3808 11.9195C21.795 12.4181 21.7392 13.1518 21.2633 13.5827L21.2237 13.6169L8.3121 24.3414C7.79999 24.7668 7.04002 24.6965 6.61466 24.1844C6.20049 23.6857 6.25627 22.9521 6.73222 22.5212L6.77173 22.4869L19.6834 11.7624Z",
    fill: "#4E5657",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.632 20.6709L20.8598 7.26761L4.56732 20.6454L6.84771 23.4832L20.8598 11.8284L35.0984 23.5086L37.632 20.6709Z",
    fill: "#D7DCDC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.26378 20.5779L20.556 7.0986C20.6362 7.03229 20.7519 7.03147 20.833 7.09663L37.6054 20.5759C37.7005 20.6523 37.7149 20.7915 37.6376 20.8857L35.2052 23.8501C35.1281 23.944 34.9894 23.9573 34.8959 23.8798L20.697 12.1141L6.82559 23.8782C6.73698 23.9534 6.60674 23.9456 6.52751 23.8647L6.51017 23.8447L4.22978 20.8803C4.15783 20.7868 4.17286 20.6531 4.26378 20.5779ZM37.1583 20.7787L20.6974 7.54992L4.70591 20.7805L6.71729 23.3953L20.554 11.6611C20.6282 11.5981 20.7342 11.5923 20.8143 11.644L20.8355 11.6595L35.006 23.4018L37.1583 20.7787Z",
    fill: "#2A323A"
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.7349 36.4297L19.4466 33.7016H11.1434L11.8551 36.4297H18.7349Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.1434 33.4824H19.4466C19.5901 33.4824 19.6948 33.618 19.6586 33.7569L18.9469 36.485C18.9218 36.5815 18.8346 36.6488 18.7349 36.6488H11.8551C11.7554 36.6488 11.6682 36.5815 11.643 36.485L10.9313 33.7569C10.8951 33.618 10.9999 33.4824 11.1434 33.4824ZM18.5655 36.2105L19.1629 33.9207H11.4269L12.0244 36.2105H18.5655Z",
    fill: "#2A323A"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.3066 33.7831L12.0183 36.5112H13.4862L12.7745 33.7831H11.3066Z",
    fill: "#4E5657",
    fillOpacity: 0.15
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask4_1_6315",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 42,
    height: 42
  }, _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 42H42V0H0V42Z",
    fill: "white"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_1_6315)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.05298 40.8267H38.7389V40.4548H3.05298V40.8267Z",
    fill: "#3A3C3E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.05298 41.5701H38.7389V40.8267H3.05298V41.5701Z",
    fill: "#D7DCDC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.90175 11.09C8.88094 11.372 8.65225 11.6005 8.37043 12.6213C8.0884 11.6005 7.85992 11.372 6.83911 11.09C7.85992 10.808 8.0884 10.5795 8.37043 9.55869C8.65225 10.5795 8.88094 10.808 9.90175 11.09",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.5714 8.23346C34.5506 8.51528 34.3219 8.74397 34.0401 9.76478C33.758 8.74397 33.5294 8.51528 32.5085 8.23346C33.5294 7.95143 33.758 7.72295 34.0401 6.70193C34.3219 7.72295 34.5506 7.95143 35.5714 8.23346",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M56.4523 25.0468V25.3261C56.4523 26.0966 55.8267 26.7222 55.0562 26.7222H39.4759C39.487 26.6411 39.5009 26.563 39.515 26.4819C39.8415 24.5275 40.3806 22.6454 41.1093 20.8586H48.9135C49.684 20.8586 50.3094 21.4839 50.3094 22.2546C50.3094 23.0253 50.935 23.6507 51.7055 23.6507H55.0562C55.8267 23.6507 56.4523 24.2761 56.4523 25.0468",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.4655 28.86C36.4447 29.1418 36.2162 29.3705 35.9342 30.3913C35.6524 29.3705 35.4237 29.1418 34.4029 28.86C35.4237 28.578 35.6524 28.3493 35.9342 27.3285C36.2162 28.3493 36.4447 28.578 37.4655 28.86",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPetProtectCopay);
export default __webpack_public_path__ + "static/media/pet-protect-copay.f8edb4289a24c068f0c6f43372e14a08.svg";
export { ForwardRef as ReactComponent };